import { PHONE_NUMBER } from '@/utils/whatsapp';
import whatsappLogo from '../assets/whatsapp.webp';

export function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${PHONE_NUMBER}?text=Hola%2C%20necesito%20ayuda%20legal`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 md:bottom-8 right-4 md:right-8 z-50 group"
    >
      <div className="relative flex items-center">
        <span className="absolute right-full mr-4 py-2 px-4 rounded-lg bg-green-500 text-white whitespace-nowrap opacity-0 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
          Necesito abogado
        </span>
        <div className="bg-green-500 text-white p-4 rounded-full shadow-lg md:hover:bg-green-600 md:transition-colors">
          <img src={whatsappLogo} alt="mensaje" className="h-6 w-6" />
        </div>
      </div>
    </a>
  );
}